
import {
  defineComponent,
  computed,
  onMounted,
} from 'vue';

import type {
  Projects,
  Postbacks,
} from '@/types';

import {
  ENTRIES,
  POSTBACK_STATUSES,
  POSTBACK_STATUSES_MAP,
  POSTBACK_EVENTS_MAP,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useEntriesNext from '@/composable/useEntries@next';

import useUrlState from '@/composable/useUrlState';

import useClipboard from '@/composable/useClipboard';

export default defineComponent({
  setup() {
    const { activeUser: user } = useUser();

    const {
      entries: projects,
      entriesLoading: projectsLoading,
      fetchEntries: fetchProjects,
    } = useEntriesNext<Projects>('/api/project/getProjects', ENTRIES);

    const {
      entries: postbacks,
      entriesLoading: postbacksLoading,
      fetchEntries: fetchPostbacks,
    } = useEntriesNext<Postbacks>('/api/postback/getPostbacksPaginator', ENTRIES);

    const postbackUrl = computed((): string => `https://api.${user.project.host}/api/postback?click_uuid=EXTERNAL_ID&payout=PAYOUT&uid=${user.id}`);

    const postbacksFilters = useUrlState('filters', {
      project_id: null,
      user_id: null,
      campaign_id: null,
      status: null,
    });

    const fetchPostbacksWrapper = async (): Promise<void> => fetchPostbacks({
      ...postbacksFilters,
    });

    const usersParams = computed(() => ({
      include: 'project',
      project_id: user.isSuperAdmin() ? postbacksFilters.project_id : undefined,
    }));

    const campaignsParams = computed(() => ({
      include: 'project,user',
      project_id: user.isSuperAdmin() ? postbacksFilters.project_id ?? undefined : undefined,
      user_id: user.isStaff() ? postbacksFilters.user_id ?? undefined : undefined,
    }));

    const { copyToClipboard } = useClipboard();

    onMounted(async (): Promise<void> => {
      if (user.isSuperAdmin()) {
        await fetchProjects();
      }
    });

    return {
      POSTBACK_STATUSES,
      POSTBACK_STATUSES_MAP,
      POSTBACK_EVENTS_MAP,
      user,
      projects,
      projectsLoading,
      postbacks,
      postbacksLoading,
      fetchPostbacksWrapper,
      postbackUrl,
      postbacksFilters,
      usersParams,
      campaignsParams,
      copyToClipboard,
    };
  },
});
